import { Container } from './icon.elements';

const Icon = ({ children, color }) => {
  return <Container $color={color}>{children}</Container>;
};

export { Icon };
